import React, { Component } from 'react'
import SpecialKeysReact from 'special-keys-react'
import { connect } from 'react-redux'
import history from 'utils/appHistory'
import { t } from 'translation'
import Slider from 'react-slick'

import { paymentApi } from '../api/payment'
import AlarmModal from 'components/AlarmModal/AlarmModal'
import ControlList from 'components/ControlList/ControlList'
import Logo from 'components/Logo/Logo'
import IndicationTypeItem from 'components/IndicationType/IndicationTypeItem'
import IndicationTypeItem2 from 'components/IndicationType/IndicationTypeItem2'
import SettingsModal from 'components/SettingsModal/SettingsModal'
import InviteModal from 'components/InviteModal/InviteModal'
import Steps from 'components/Steps/Steps'
import Spinner from 'components/ui/Spinner/Spinner'

import indicationImg1 from 'assets/indication_1.png'
import indicationImg2 from 'assets/indication_2.png'
import indicationImg3 from 'assets/indication_3.png'

import HospitalIcon from '../assets/icons/hospital.svg'
import HeartbeatIcon from '../assets/icons/heartbeat.svg'
import SunIcon from '../assets/icons/sun.svg'
import PulseIcon from '../assets/icons/pulse.svg'

import { setIndicationType } from 'store/actions'
import { SLEEP, ANXIETY, PAIN, AWAKENING } from 'utils/constants'

class IndicationSelectPage extends Component {
  constructor() {
    super()
    document.documentElement.classList.remove('no_scale_mod')
    this.slider = React.createRef()
    this.state = {
      areSettingsOpen: false,
      isAlarmOpen: false,
      isInviteOpen: false,
      isLoading: true,
      currentIndication: -1,
      activeSlide: 0,
      windowWidth: window.innerWidth,
    }

    this.sliderSettings = {
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      arrows: false,
      afterChange: (current, next) => {
        this.setState({ activeSlide: current })
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '26px',
          },
        },
      ],
    }

    this.onWindowResize = this.onWindowResize.bind(this)

    SpecialKeysReact.config({
      left: () => {
        this.backBtn.click()
      },
      right: () => {},
      up: () => {
        this.indicationRef.current[
          this.state.currentIndication - 1 < 0
            ? this.indicationRef.current.length - 1
            : this.state.currentIndication - 1
        ].focus()
        this.setState({
          currentIndication:
            this.state.currentIndication - 1 < 0
              ? this.indicationRef.current.length - 1
              : this.state.currentIndication - 1,
        })
      },
      down: () => {
        this.indicationRef.current[
          this.state.currentIndication + 1 > this.indicationRef.current.length - 1
            ? 0
            : this.state.currentIndication + 1
        ].focus()
        this.setState({
          currentIndication:
            this.state.currentIndication + 1 > this.indicationRef.current.length - 1
              ? 0
              : this.state.currentIndication + 1,
        })
      },
      backspace: () => {},
      enter: () => {
        this.indicationRef.current[this.state.currentIndication].click()
      },
    })

    this.mainElement = React.createRef()
    this.indicationRef = {
      current: [],
    }
  }

  backBtn = null

  attachBackBtnRef = (btn) => (this.backBtn = btn)

  toggleAlarmHandler = () => {
    this.setState((prevState) => ({
      isAlarmOpen: !prevState.isAlarmOpen,
    }))
  }

  toggleSettingsHandler = () => {
    this.setState((prevState) => ({
      areSettingsOpen: !prevState.areSettingsOpen,
    }))
  }

  toggleInviteHandler = () => {
    this.setState((prevState) => ({
      isInviteOpen: !prevState.isInviteOpen,
    }))
  }

  sliderDotHandler = (index) => {
    if (this.slider.current) {
      this.slider.current.slickGoTo(index)
    }
  }

  indicationTypes = [
    {
      title: t('treatment.SLEEPING'),
      permission: 'sleep',
      Icon: PulseIcon,
      slideIndex: 0,
    },
    {
      title: t('treatment.PAIN'),
      permission: 'pain',
      Icon: HospitalIcon,
      slideIndex: 1,
    },
    {
      title: t('treatment.ANXIETY'),
      permission: 'anxiety',
      Icon: HeartbeatIcon,
      slideIndex: 2,
    },
    {
      title: t('treatment.AWAKENING'),
      permission: 'awakening',
      Icon: SunIcon,
      slideIndex: 3,
    },
  ]

  indicationTypes2 = [
    {
      id: 'tHRk8DdDdmj3dKJlaASM',
      title: t('treatmentSlides.slide1.TITLE'),
      subtitle: t('treatmentSlides.slide1.SUBTITLE'),
      permission: 'sleep',
      img: indicationImg1,
      clickTreatment: () => {
        this.props.setIndicationType(SLEEP)
        history.push('/song-select')
      },
    },
    {
      id: 'xZ6WqdW444t6a9rvJ34V',
      title: t('treatmentSlides.slide2.TITLE'),
      subtitle: t('treatmentSlides.slide2.SUBTITLE'),
      permission: 'pain',
      img: indicationImg2,
      controls: [
        {
          clickTreatment: () => {
            this.props.setIndicationType(PAIN)
            history.push('/song-select')
          },
          title: t('treatment.PAIN'),
          permission: 'pain',
          Icon: HospitalIcon,
        },
        {
          clickTreatment: () => {
            this.props.setIndicationType(ANXIETY)
            history.push('/song-select')
          },
          title: t('treatment.ANXIETY'),
          permission: 'anxiety',
          Icon: HeartbeatIcon,
        },
      ],
      clickTreatment: () => {
        this.props.setIndicationType(PAIN)
        history.push('/song-select')
      },
    },
    {
      id: '024cg9zo35dNGQLKYvOH',
      title: t('treatmentSlides.slide2.TITLE'),
      subtitle: t('treatmentSlides.slide2.SUBTITLE'),
      img: indicationImg2,
      mobileOnly: true,
      permission: 'anxiety',
      clickTreatment: () => {
        this.props.setIndicationType(ANXIETY)
        history.push('/song-select')
      },
    },
    {
      id: 'WncWXkb3cyYYwtLA21KZ',
      title: t('treatmentSlides.slide3.TITLE'),
      subtitle: t('treatmentSlides.slide3.SUBTITLE'),
      permission: 'awakening',
      img: indicationImg3,
      clickTreatment: () => {
        this.props.setIndicationType(AWAKENING)
        history.push('/song-select')
        // if (window.cordova)
        //   history.push({
        //     pathname: '/song-select',
        //     query: {
        //       alarm: true,
        //     },
        //   })
        // else history.push('/song-select', { alarm: true })
      },
    },
  ]

  componentDidMount() {
    this.props.setIndicationType(null)
    !this.props.isDoctor && !this.props.isPro
      ? paymentApi
          .getPaymentList()
          .then((res) =>
            this.setState({ paymentData: res?.result?.paymentMethod, isLoading: false })
          )
      : this.setState({ isLoading: false })

    this.mainElement.current.focus()

    window.addEventListener('resize', this.onWindowResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isLoading && !this.state.isLoading) this.mainElement.current.focus()
  }

  onWindowResize() {
    this.setState({ windowWidth: window.innerWidth })
  }

  render() {
    if (
      !this.state.paymentData &&
      !this.state.isLoading &&
      !this.props.isPro &&
      !this.props.isDoctor
    )
      history.push('my-account3')

    return (
      <div ref={this.mainElement} {...SpecialKeysReact.events} tabIndex="2">
        {this.state.isLoading ? (
          <Spinner style={{ marginTop: '40vh' }} />
        ) : (
          <>
            {!this.state.isInviteOpen && (
              <>
                <section className="section offset_v2_mod session_type_mod session_type_mod_v2">
                  {/* TODO: Hide steps until they are fixed */}
                  {/* <Steps active={1}/> */}
                  <ControlList
                    toggleAlarmHandler={this.toggleAlarmHandler}
                    toggleSettingsHandler={this.toggleSettingsHandler}
                    toggleInviteHandler={this.toggleInviteHandler}
                    attachBackBtnRef={this.attachBackBtnRef}
                    recommander={this.props.isPro ? true : false}
                  />
                  <div className="section_in center_content_mod">
                    <div className="section_heading_wrap no_scale_mod">
                      <div className="section_heading offset_mod desktop_mod">
                        <h2 className="section_title center_mod title_step_center_mod">
                          <div className="section_title_step">
                            <span className="section_title_number one">1</span>
                          </div>
                          {t('treatment.PLEASE_CHOOSE_A_TREATMENT')}
                        </h2>
                      </div>
                      <div className="session_type_descr default_text desktop_mod">
                        <p>{t('treatment.TREATMENT_DESCR')}</p>
                      </div>
                    </div>

                    <div className="session_type_content">
                      <div className="indication_controls mobile_mod">
                        {this.indicationTypes.map(
                          (treatmendModeProps, index) =>
                            this.props.permissions.indications[
                              treatmendModeProps.permission
                            ] && (
                              <IndicationTypeItem
                                key={treatmendModeProps.title}
                                {...treatmendModeProps}
                                indicationRef={this.indicationRef}
                                index={index}
                                slider={this.slider}
                                activeSlide={this.state.activeSlide}
                                sliderDotHandler={this.sliderDotHandler}
                              />
                            )
                        )}
                      </div>
                      <Slider
                        ref={this.slider}
                        className="session_type_list"
                        {...this.sliderSettings}
                      >
                        {this.indicationTypes2.map((treatmendModeProps, index) => {
                          if (this.state.windowWidth >= 768) {
                            if (!treatmendModeProps.mobileOnly) {
                              if (
                                this.props.permissions.indications[
                                  treatmendModeProps.permission
                                ]
                              ) {
                                if (treatmendModeProps?.hasOwnProperty('controls')) {
                                  const controls = treatmendModeProps?.controls.filter(
                                    (control) =>
                                      this.props.permissions.indications[
                                        control.permission
                                      ]
                                  )

                                  return (
                                    <IndicationTypeItem2
                                      {...treatmendModeProps}
                                      controls={controls}
                                      key={treatmendModeProps.id}
                                      index={index}
                                    />
                                  )
                                }

                                return (
                                  <IndicationTypeItem2
                                    {...treatmendModeProps}
                                    key={treatmendModeProps.id}
                                    index={index}
                                  />
                                )
                              }
                            }
                            return null
                          }
                          if (
                            this.props.permissions.indications[
                              treatmendModeProps.permission
                            ]
                          )
                            return (
                              <IndicationTypeItem2
                                {...treatmendModeProps}
                                key={treatmendModeProps.id}
                                index={index}
                                isMobile={true}
                              />
                            )
                        })}
                      </Slider>
                    </div>
                  </div>
                  <div className="player_bottom_wrap">
                    <div className="player_bottom v2_mod">
                      <Logo modClass="bar_mod" />
                    </div>
                  </div>
                </section>
                <SettingsModal
                  toggleSettingsHandler={this.toggleSettingsHandler}
                  areSettingsOpen={this.state.areSettingsOpen}
                />
                <AlarmModal
                  isAlarmModalOpen={this.state.isAlarmOpen}
                  toggleAlarmHandler={this.toggleAlarmHandler}
                />
              </>
            )}
            {this.props.isPro && (
              <InviteModal
                isInviteModalOpen={this.state.isInviteOpen}
                toggleInviteHandler={this.toggleInviteHandler}
              />
            )}
          </>
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  auth: {
    attributes: { permissions, isPro },
    isDoctor,
  },
}) => ({ permissions, isPro, isDoctor })

const willMapDispatchToProps = {
  setIndicationType,
}

export default connect(mapStateToProps, willMapDispatchToProps)(IndicationSelectPage)
